define('home/templates/channelModerators',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"padding-default\">\n<div class=\"spacing-default\">\n<h1 class=\"text-larger text-gray-darker spacing-bottom-narrow\">"
    + alias2(helpers.gettext.call(alias1,"Moderators",{"name":"gettext","hash":{},"data":data}))
    + "</h1>\n<p class=\"text-gray\">"
    + alias2(helpers.gettext.call(alias1,"Add moderators to help manage your channel. Moderators can mark discussions and comments as spam, as well as ban unwanted users.",{"name":"gettext","hash":{},"data":data}))
    + "</p>\n</div>\n</div>\n<section data-role=\"moderators\" class=\"channel-mod__list\"></section>\n<div class=\"padding-default\">\n<section data-role=\"moderator-form\" class=\"spacing-default\"></section>\n</div>\n";
},"useData":true})

});
